export const toNumber = (value: string | number): number => {
  if (typeof value === 'number') {
    return isNaN(value) ? 0 : value;
  }
  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
};
